// 'summer' | 'winter' — переключается перед сборкой
export const SEASON = 'summer'
